"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ioTsTaggedUnionInterpreter = void 0;
var utils_1 = require("@morphic-ts/common/lib/utils");
var t = require("io-ts");
var config_1 = require("../config");
var hkt_1 = require("../hkt");
var coerce = function (arr) { return arr; };
/**
 *  @since 0.0.1
 */
exports.ioTsTaggedUnionInterpreter = utils_1.memo(function () { return ({
    _F: hkt_1.IoTsURI,
    taggedUnion: function (_tag, dic, name, config) { return function (env) {
        return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(t.union(coerce(utils_1.collect(dic, function (_, getType) { return getType(env).type; })), name), env, {}));
    }; }
}); });
